import { NgModule } from '@angular/core';

import { AboutBudgetRoutingModule, routedComponents } from './about-budget-routing.module';
import { SharedModule } from '../shared/shared.module';
import {
  ScheduleModule,
  DialogModule,
  CalendarModule,
  CheckboxModule,
  InputTextModule,
  DropdownModule,
  MultiSelectModule
} from 'primeng/primeng';
import { EventService } from '../events/shared';

@NgModule({
  imports: [
    AboutBudgetRoutingModule,
    SharedModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    ScheduleModule,
  ],
  declarations: [

    routedComponents
  ],
  providers: [EventService],
})
export class AboutBudgetModule { }



// WEBPACK FOOTER //
// ./src/app/about-budget/about-budget.module.ts